import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { debounceTime } from 'rxjs';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, Tc } from '../../../../core/_infrastructure/types/common';
import { FilterSearchingPuntoInspeccionViewModel } from '../puntoinspeccion.types';

@Component({
    selector: 'app-puntoinspeccion-filter',
    templateUrl: './puntoinspeccion-filter.component.html',
})
export class PuntoInspeccionFilterComponent extends ComponentBase implements OnInit {
    @Input() listPais: Tc[];
    @Input() listProvincia: Tc[];
    @Input() listMunicipio: Tc[];
    @Input() listTipoPuntoInspeccion: Tc[];

    @Input() lastFilter: FilterSearchingPuntoInspeccionViewModel;

    @Output() search = new EventEmitter<FilterSearchingPuntoInspeccionViewModel>();
    @Output() cleanForm = new EventEmitter<any>(); // Informa que el formulario se ha reseteado
    @Output() selectProvincia = new EventEmitter<number>(); // Informa que ha cambiado la provincia
    @Output() selectPais = new EventEmitter<number>(); // Informa que ha cambiado el pais

    paisEspania = 0;
    public isCollapsed = false;

    listSiNoTodos: SelectItem[] = [
        { label: 'Sí', value: EnumSiNoTodos.SI },
        { label: 'NO', value: EnumSiNoTodos.NO },
        { label: 'TODOS', value: EnumSiNoTodos.TODOS },
    ];

    constructor(
        private fb: FormBuilder,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        protected authService: AuthService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.createForm();
        this.recoverLastSearch();
    }

    private createForm() {
        this.form = this.fb.group({
            IdPais: null,
            IdProvincia: null,
            Codigo: '',
            Descripcion: '',
            IdTipoPuntoInspeccion: null,
            IdMunicipio: null,
            CodigoTraces: '',
            Activo: EnumSiNoTodos.TODOS,
            HabilitadoParaImportacion: EnumSiNoTodos.TODOS,
            HabilitadoParaExportacion: EnumSiNoTodos.TODOS,
            HabilitadoSanidadExterior: EnumSiNoTodos.TODOS,
            CodigoPostal: '',
            Localidad: '',
            ReasignableEx: EnumSiNoTodos.TODOS,
        });
    }

    /**
     * Recover last search from the previous payload
     */
    private recoverLastSearch(): void {
        if (this.lastFilter) {
            this.form.setValue({
                IdPais: this.lastFilter.Descripcion,
                IdProvincia: this.lastFilter.IdProvincia,
                Codigo: this.lastFilter.Codigo,
                Descripcion: this.lastFilter.Descripcion,
                IdTipoPuntoInspeccion: this.lastFilter.IdTipoPuntoInspeccion,
                IdMunicipio: this.lastFilter.IdMunicipio,
                CodigoTraces: this.lastFilter.CodigoTraces,
                Activo: this.lastFilter.Activo,
                HabilitadoParaImportacion: this.lastFilter.HabilitadoParaImportacion,
                HabilitadoParaExportacion: this.lastFilter.HabilitadoParaExportacion,
                HabilitadoSanidadExterior: this.lastFilter.HabilitadoSanidadExterior,
                CodigoPostal: this.lastFilter.CodigoPostal,
                Localidad: this.lastFilter.Localidad,
                ReasignableEx: this.lastFilter.ReasignableEx,
            });
            this.form.markAsDirty();

            setTimeout(() => {
                this.onSearch(null);
            }, 200);
        }

        // As soon as the user changes the "filter", the previous lastFilter pagination values has no sense
        this.form.valueChanges.pipe(debounceTime(500)).subscribe(values => {
            if (values) {
                this.clearPaginationFilter();
            }
        });
    }

    private clearPaginationFilter() {
        if (!this.lastFilter) {
            return;
        }
        this.lastFilter.PageNumber = 0;
        this.lastFilter.Asc = 0;
        this.lastFilter.OrderBy = '';
    }

    onSelectPais() {
        this.selectPais.emit(this.form.value.IdPais);

        this.form.patchValue({
            IdProvincia: null,
            IdMunicipio: null,
            IdTipoPuntoInspeccion: null,
            Codigo: '',
        });
    }

    onSelectProvincia() {
        this.selectProvincia.emit(this.form.value.IdProvincia);

        this.form.patchValue({
            IdMunicipio: null,
        });
    }

    onSearch($event: any): void {
        $event?.stopPropagation();
        this.searchingButton = true;
        this.isCollapsed = true;

        const payload: FilterSearchingPuntoInspeccionViewModel = {
            ...this.form.value,
            PageNumber: this.lastFilter?.PageNumber || 0,
            Asc: this.lastFilter?.Asc || 0,
            OrderBy: this.lastFilter?.OrderBy || '',
        };

        this.search.emit(payload);
    }

    /**
     * Manejador del evento de reseteo del formulario de búsqueda.
     * @param $event any
     * @return void
     */
    onCleanForm($event: any): void {
        $event?.stopPropagation();

        this.form.setValue({
            IdPais: null,
            IdProvincia: null,
            Codigo: '',
            Descripcion: '',
            IdTipoPuntoInspeccion: null,
            IdMunicipio: null,
            CodigoTraces: '',
            Activo: EnumSiNoTodos.TODOS,
            HabilitadoParaImportacion: EnumSiNoTodos.TODOS,
            HabilitadoParaExportacion: EnumSiNoTodos.TODOS,
            HabilitadoSanidadExterior: EnumSiNoTodos.TODOS,
            ReasignableEx: EnumSiNoTodos.TODOS,
            CodigoPostal: null,
            Localidad: '',
        });
        this.form.markAsPristine();

        this.searchingButton = false;
        this.isCollapsed = false;

        this.cleanForm.emit();
    }
}
